import { render, staticRenderFns } from "./histogram4.vue?vue&type=template&id=e8a85002&scoped=true&"
import script from "./histogram4.vue?vue&type=script&lang=js&"
export * from "./histogram4.vue?vue&type=script&lang=js&"
import style0 from "./histogram4.vue?vue&type=style&index=0&id=e8a85002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a85002",
  null
  
)

export default component.exports